import { IconAlertTriangle, IconRobot } from "@tabler/icons-react";
import type { Prorrateo } from "@/lib/types";
import { Alert } from "@/components/ui";

/**
 * Prorrateo automático (CA/OC · configurable por el administrador por tipo y subtipo):
 *  · confirmado por el sistema → aviso informativo (no se puede modificar);
 *  · no se pudo completar → advertencia con el motivo (el solicitante lo captura a mano).
 * Sin prorrateo automático no renderiza nada.
 */
export function AvisoProrrateoAutomatico({ prorrateo }: { prorrateo: Prorrateo | null | undefined }) {
  if (!prorrateo) return null;
  if (prorrateo.confirmadoAutomaticamente) {
    return (
      <Alert variant="info" icon={<IconRobot size={16} stroke={1.7} />}>
        Este prorrateo se hizo automáticamente con el centro de costo y la cuenta contable del documento de SAP y no se
        puede modificar.
      </Alert>
    );
  }
  if (prorrateo.avisoAutomatico && prorrateo.estado !== "Confirmado") {
    return (
      <Alert variant="warning" icon={<IconAlertTriangle size={16} stroke={1.7} />}>
        {prorrateo.avisoAutomatico}
      </Alert>
    );
  }
  return null;
}
